import { postCloudfrontCookies } from 'endpoints/cloudfront';

const REFRESH_INTERVAL_MS = 45 * 60 * 1000; // refresh before 60m TTL
let refreshTimerId = null;

const safeRefresh = () => (
  postCloudfrontCookies().catch(() => null)
);

export const startCloudfrontCookieRefresh = () => {
  if (refreshTimerId) return;

  safeRefresh();
  refreshTimerId = setInterval(() => {
    safeRefresh();
  }, REFRESH_INTERVAL_MS);
};

export const stopCloudfrontCookieRefresh = () => {
  if (!refreshTimerId) return;

  clearInterval(refreshTimerId);
  refreshTimerId = null;
};
